import { render, staticRenderFns } from "./moneyRecord.vue?vue&type=template&id=c9d0460e&scoped=true&"
import script from "./moneyRecord.vue?vue&type=script&lang=js&"
export * from "./moneyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d0460e",
  null
  
)

export default component.exports